import React from 'react';
import { mainContentPadding } from '../MainContentContainer';
import { PRScrollView } from '../../shared/Scroll';

export type SideDrawerContentContainerOwnProps = {
    children: React.ReactNode;
};

export type SideDrawerContentContainerProps = SideDrawerContentContainerOwnProps;

const SideDrawerContentContainer: React.FC<SideDrawerContentContainerProps> = ({ children }) => {
    return (
        <PRScrollView
            style={{ flex: 1, width: '100%' }}
            contentContainerStyle={{
                padding: mainContentPadding,
            }}
        >
            {children}
        </PRScrollView>
    );
};

export default React.memo(SideDrawerContentContainer);
